import CountryProfile from './CountryProfile';

export default CountryProfile;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/index.js